import { twMerge } from "tailwind-merge";
import { useStore } from "../../../store/store";
import BackArrow from "../../../assets/BackArrow.svg";
import { TabId } from "../../store/types";
import TabIcon from "./TabIcon";

interface IProps {
	title: string;
	number: TabId;
	badge?: number;
}

const Tab = (props: IProps) => {
	const activeTab = useStore((state) => state.activeTab);
	const setActiveTab = useStore((state) => state.setActiveTab);
	const liveActive = useStore((state) => state.liveActive);
	const status = useStore((state) => state.status);

	const showNotif =
		props.badge != null && props.badge > 0 && activeTab !== props.number;

	return (
		<li
			className={twMerge(
				"relative h-full min-w-0 flex-1 cursor-pointer overflow-visible px-0.5 py-1.5 text-center text-primary sm:px-1 sm:py-2",
				"before:absolute before:bottom-0 before:left-0 before:z-50 before:h-1 before:w-full before:translate-y-1 before:rounded-lg before:transition-all before:duration-200 before:content-['']",
				activeTab === props.number && "before:bg-white",
				activeTab === 4 && "w-full flex-none"
			)}
			onClick={() => {
				if (props.number === 4) {
					setActiveTab(2);
					return;
				}
				setActiveTab(props.number);
			}}
		>
			{/* Badge on tab cell — NOT inside .truncate, so it stays visible in tight rows */}
			{showNotif ? (
				<span
					className="pointer-events-none absolute right-0 top-0 z-20 flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-red-500 px-0.5 text-[9px] font-bold leading-none text-white shadow-sm sm:text-[10px]"
					aria-hidden
				>
					{props.badge! > 99 ? "99+" : props.badge}
				</span>
			) : null}

			{props.number === 4 ? (
				<div
					className={twMerge(
						"flex w-full items-center justify-start gap-2 text-center",
					)}
				>
					<img src={BackArrow} className="h-[15px] shrink-0" alt="" />
					<span className="min-w-0 max-w-full truncate text-xs sm:text-sm">{props.title}</span>
					{activeTab === 4 ? (
						<div
							className={twMerge(
								"ms-auto h-2 w-2 shrink-0 rounded-full",
								liveActive === 0 && status === -1 && "bg-question",
								liveActive === 0 && status === 1 && "bg-red-600",
								liveActive === 1 && status === 0 && "bg-[#21FF37]",
							)}
						/>
					) : null}
				</div>
			) : (
				<div className="mx-auto flex w-full min-w-0 max-w-full flex-col items-center justify-center gap-0.5">
					<div className="flex h-6 w-full max-w-full items-center justify-center">
						<TabIcon number={props.number} />
					</div>
					<div
						className={twMerge(
							"flex w-full min-w-0 max-w-full items-center justify-center gap-1",
						)}
					>
						<span className="min-w-0 max-w-full truncate text-center text-[10px] leading-tight sm:text-xs">
							{props.title}
						</span>
						{activeTab === props.number ? (
							<div
								className={twMerge(
									"shrink-0 rounded-full h-1.5 w-1.5 sm:h-2 sm:w-2",
									liveActive === 0 && status === -1 && "bg-question",
									liveActive === 0 && status === 1 && "bg-red-600",
									liveActive === 1 && status === 0 && "bg-[#21FF37]",
								)}
							/>
						) : null}
					</div>
				</div>
			)}
		</li>
	);
};

export default Tab;
